import React, { ChangeEvent } from "react";
import styled from "styled-components";
import { colors } from "../../../../utils/theme";

interface InputProps {
  placeholder: string;
  type: string;
  legendError: string;
  expressionRegular?: RegExp;
  state: {
    field: string;
    isValid: boolean | null;
  };
  changeState: (newState: { field: string; isValid: boolean | null }) => void;
  validateYear?: boolean;
   
}

interface InputContainerProps {
  $valido: boolean;
}

const InputContainer = styled.div<InputContainerProps>`

  .input {
    width: 100%;
    height: 40px;
    border-radius: 5px;
    border: none;
    outline: 1px solid ${({ $valido }) => ($valido === null ? "#d9d9d9" : $valido ? "#d9d9d9" : "red")};
    padding-left: 10px;
    margin-bottom: 1rem;
    color: ${colors.fifth};
    &::placeholder {
      color: #d4d4d4;
    }

    &:focus,
    &:active {
      border: 1px solid ${({ $valido }) => ($valido === null ? "#d9d9d9" : $valido ? "#d9d9d9" : "red")};
      outline: none;
    }
  }

  .errorValidation {
    color: red;
    margin-left: 10px;
    margin-top: -0.5rem;
    font-weight: bold;
  }
`;

const Input_Form: React.FC<InputProps> = ({
  placeholder,
  type,
  legendError,
  expressionRegular,
  state,
  changeState,
  validateYear,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {  
    changeState({ ...state, field: e.target.value });
  };

  const handleValidation = () => {
    if (expressionRegular) {
      if (expressionRegular.test(state.field)) {
        changeState({ ...state, isValid: true });
      } else {
        changeState({ ...state, isValid: false });
      }
    }
    if (validateYear) {
      const currentYear = new Date().getFullYear() - 1;
      const inputYear = parseInt(state.field);
    
      if (inputYear > currentYear || inputYear < 1900) {
        changeState({ ...state, isValid: false });
      }
    }
  };
  const isValid = state.isValid !== false;
  return (
    <InputContainer $valido={isValid}>
      <input
        className="input"
        placeholder={placeholder}
        type={type}
        value={state.field}
        onChange={handleChange}
        onKeyUp={handleValidation}
        onBlur={handleValidation}
      />
      {state.isValid === false && <p className="errorValidation">{legendError}</p>}
    </InputContainer>
  );
};

export default Input_Form;
